import { Component, inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
} from '@angular/material/dialog';
import { FormDialInfo } from './form-dial.model';
import { DateTime } from 'luxon';
import { MatDivider } from '@angular/material/divider';
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import {
  MatDatepickerInput,
  MatDatepickerToggle,
  MatDatepicker,
} from '@angular/material/datepicker';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { MatButton } from '@angular/material/button';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatSelect, MatOption } from '@angular/material/select';

@Component({
  selector: 'app-form-dialog',
  templateUrl: './form-dial.component.html',
  styleUrls: ['./form-dial.component.scss'],
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDivider,
    MatFormField,
    MatLabel,
    MatInput,
    FormsModule,
    MatDatepickerInput,
    MatDatepickerToggle,
    MatSuffix,
    MatDatepicker,
    CdkTextareaAutosize,
    MatDialogActions,
    MatButton,
    MatCheckbox,
    MatSelect,
    MatOption,
  ],
})
export class FormDialComponent {
  /** Inject services. */
  readonly dialogRef = inject<MatDialogRef<FormDialComponent>>(MatDialogRef);
  readonly dialInfo = inject<FormDialInfo>(MAT_DIALOG_DATA);

  data: Record<string, unknown> = {};

  constructor() {
    const dialInfo = this.dialInfo;

    dialInfo.formDef.forEach(field => {
      if (field.type === 'bool') {
        this.data[field.id] = field.value === true || field.value === 'true';
        return;
      }

      if (field.type === 'option') {
        const value = field.value;
        if (Array.isArray(value)) {
          this.data[field.id] = value;
        } else if (value !== undefined && value !== null && value !== '') {
          this.data[field.id] = [value];
        } else {
          this.data[field.id] = [];
        }
        return;
      }

      this.data[field.id] = field.value;
    });
  }

  onConfirm(): void {
    this.dialInfo.formDef
      .filter(field => field.type == 'date')
      .forEach(field => {
        const dt = this.data[field.id] as DateTime;
        if (dt?.isValid) {
          this.data[field.id] = dt.toFormat('yyyy-MM-dd');
        }
      });

    this.dialogRef.close(this.data);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
